import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router";
import { useSelector } from 'react-redux';
import { getCountries } from '../AddressCard/reducer';
import './styles.css';

const CounterpartiesTableComponent = ({
                                          counters = [],
                                          languageString = 'ru',
                                          loadCounters,
                                          hasMore,
                                          t = (key) => key,
                                          isLoading = false,
                                          sortConfig = { key: null, direction: "asc" },
                                          requestSort
                                      }) => {
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();
    const countries = useSelector((state) => getCountries(state.address));

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);

        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    const arrayCountries = countries && countries.countries ? Object.values(countries.countries).map(country => ({
        'key': country.iso.toLowerCase(),
        'value': country.iso.toLowerCase(),
        'flag': country.iso.toLowerCase(),
        'text': country[`country_${languageString}`] + ' ' + country.emoji,
        'states': country.states
    })) : [];

    const findCountryText = (countryCode) => {
        const country = arrayCountries.find(c => c.key === countryCode);
        return country ? country.text : " ";
    };

    const handleRowClick = (record) => {
        navigate(`/counterparty/${record.id}`);
    };

    const dataSource = counters.map((item, index) => ({
        key: item.id || index,
        id: item.id || index,
        name: languageString === 'ru' ? item.name : item.name_en,
        country: item.country,
        countryText: findCountryText(item.country?.toLowerCase()),
        status: languageString === 'ru' ? item.crm_status?.status_name?.ru : item.crm_status?.status_name?.en,
        lastEvent: `${item.crm_last_event?.on_date?.split('-').reverse().join('.') || ''} ${item.crm_last_event?.on_time || ''}`.trim(),
        rawData: item
    }));

    const desktopColumns = [
        {
            title: t('nameTable'),
            dataIndex: 'name',
            key: 'name',
            width: '60%',
            sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
            showSorterTooltip: false,
            render: (text) => <span style={{ fontWeight: 500 }}>{text || ''}</span>
        },
        {
            title: t('country'),
            dataIndex: 'countryText',
            key: 'country',
            width: '10%',
            sorter: (a, b) => (a.countryText || '').localeCompare(b.countryText || ''),
            showSorterTooltip: false,
            render: (text) => text || ''
        },
        {
            title: t('counterStatus'),
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b) => (a.status || '').localeCompare(b.status || ''),
            showSorterTooltip: false,
            render: (text) => text || ''
        },
        {
            title: t('lastEvent'),
            dataIndex: 'lastEvent',
            key: 'lastEvent',
            sorter: (a, b) => {
                if (!a.lastEvent && !b.lastEvent) return 0;
                if (!a.lastEvent) return 1;
                if (!b.lastEvent) return -1;

                const dateA = new Date(a.lastEvent.split(' ')[0]?.split('.').reverse().join('-') + ' ' + (a.lastEvent.split(' ')[1] || '00:00'));
                const dateB = new Date(b.lastEvent.split(' ')[0]?.split('.').reverse().join('-') + ' ' + (b.lastEvent.split(' ')[1] || '00:00'));
                return dateA - dateB;
            },
            showSorterTooltip: false,
            render: (text) => text || ''
        }
    ];

    const mobileColumns = [
        {
            title: t('counterparty'),
            key: 'counterparty',
            render: (_, record) => (
                <div className="mobile-counterparty-card">
                    <div className="mobile-counterparty-header">
                        <div className="mobile-counterparty-name">{record.name || ''}</div>
                    </div>
                    <div className="mobile-counterparty-location">
                        <strong>{t('country')}:</strong> {record.countryText || ''}
                    </div>
                    <div className="mobile-counterparty-contact">
                        <strong>{t('counterStatus')}:</strong> {record.status || ''}
                    </div>
                    {record.lastEvent && (
                        <div className="mobile-counterparty-contact">
                            <strong>{t('lastEvent')}:</strong> {record.lastEvent}
                        </div>
                    )}
                </div>
            )
        }
    ];

    const columns = isMobile ? mobileColumns : desktopColumns;

    return (
        <div className="counterparties-table-container">
            <InfiniteScroll
                dataLength={dataSource.length}
                next={loadCounters}
                hasMore={hasMore && !isLoading}
                loader={<div style={{ textAlign: 'center', padding: '16px' }}>{t('loading')}</div>}
                endMessage={
                    <div style={{ textAlign: 'center', padding: '16px', color: '#999' }}>
                        {dataSource.length > 0 ? t('dataLoaded') : ''}
                    </div>
                }
                scrollThreshold={0.8}
            >
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    size="small"
                    scroll={isMobile ? { x: 'max-content' } : undefined}
                    rowClassName={(record, index) => {
                        return index % 2 === 0 ? 'table-row-even' : 'table-row-odd';
                    }}
                    locale={{
                        emptyText: (
                            <div style={{ textAlign: 'center', padding: '40px', color: '#666', fontStyle: 'italic' }}>
                                {t('nothingFound') || 'Ничего не найдено'}
                            </div>
                        )
                    }}
                    className={`custom-counterparties-table ${isMobile ? 'mobile-table' : ''}`}
                    onRow={(record) => ({
                        onClick: () => handleRowClick(record),
                        style: { cursor: 'pointer' }
                    })}
                />
            </InfiniteScroll>
        </div>
    );
};

export default CounterpartiesTableComponent;